// lib/components/frame/frame-props.ts
var FrameWidth = {
  Large: {
    type: "large"
  },
  Middle: {
    type: "middle"
  }
};

export {
  FrameWidth
};
